(function($){
  const BP = 1000;

  const $heatSlider = $('.heat-chart__slider');
  const $infusionSlider = $('.infusion-chart__slider');

  const slickSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
    centerMode: true,
    centerPadding: '24px',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 758,
        settings: {
          slidesToShow: 3,
          centerMode: false
        }
      }
    ]
  };

  function mountOrDestroy($el){
    if (!$el || !$el.length) return;
    if (window.innerWidth <= BP) {
      if (!$el.hasClass('slick-initialized') && $.fn && $.fn.slick) {
        $el.slick(slickSettings);
      }
    } else if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
    }
  }

  function updateAll(){
    mountOrDestroy($heatSlider);
    mountOrDestroy($infusionSlider);
  }

  // 1) Inicia en DOMContentLoaded (más fiable en móvil)
  document.addEventListener('DOMContentLoaded', function(){
    // Si Slick aún no está cargado, intenta de nuevo en window.load
    if (!$.fn || !$.fn.slick) {
      window.addEventListener('load', updateAll, { once: true });
    } else {
      updateAll();
    }
  });

  // 2) Recalcula en resize (con debounce)
  window.addEventListener('resize', debounce(updateAll, 150));

  function debounce(fn, wait){
    let t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); };
  }
})(jQuery);
